// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"h7yRb","contentOuter":"_3Wq6p","heading":"_33qzg","detailTextWrap":"QDi_2","description":"_2pgps","imageWrapper":"_2otoy","blurBg":"ocK3m","customerName":"_3Dx0S"};